export const isExist = value =>
  value !== null && value !== '' && typeof value !== 'undefined';

export const encodeURIString = url =>
  encodeURI(url)
    .replace(/\(/g, '%28')
    .replace(/\)/g, '%29');

export const pipe = (func1, func2) => x => func2(func1(x));
